import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import AboutPage from "./view/AboutPage";
import DestinationPage from "./view/DestinationPage";
import FlightsPage from "./view/FlightsPage";
import Homepage from "./view/Homepage";
import ContactPage from "./view/ContactPage";
import PrivacyPage from "./view/PrivacyPage";
import TermsOfUsePage from "./view/TermsOfUsePage";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import BackToTop from "./components/common/BackToTop";
import PopUp from "./components/common/PopUp";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/destination" element={<DestinationPage />} />
        <Route path="/explore-flights" element={<FlightsPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
      </Routes>
      <Footer />
      <BackToTop />
      <PopUp/>
    </Router>
  );
}

export default App;
